(() => {
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => Array.from(root.querySelectorAll(sel));

  function updateCartCount(count) {
    $$('[data-mb-cart-count-global]').forEach((el) => {
      el.textContent = count;
      el.hidden = count < 1;
    });
  }

  async function refreshCartCount() {
    try {
      const r = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
      if (!r.ok) return;
      const cart = await r.json();
      updateCartCount(cart.item_count || 0);
    } catch (_) {}
  }

  function initMobileMenu() {
    const drawer = $('[data-mb-mobile-drawer]');
    if (!drawer) return;
    const close = () => {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
    };
    $$('[data-mb-menu-open]').forEach((b) => b.addEventListener('click', () => {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
    }));
    $$('[data-mb-menu-close]', drawer).forEach((b) => b.addEventListener('click', close));
    drawer.addEventListener('click', (e) => { if (e.target === drawer) close(); });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && drawer.classList.contains('is-open')) close(); });
  }

  function initMobileSearch() {
    const panel = $('[data-mb-mobile-search]');
    if (!panel) return;
    const input = $('[data-mb-mobile-search-input]', panel);
    const close = () => { panel.classList.remove('is-open'); panel.setAttribute('aria-hidden','true'); document.documentElement.style.overflow=''; };
    $$('[data-mb-search-open]').forEach((b)=>b.addEventListener('click',()=>{ panel.classList.add('is-open'); panel.setAttribute('aria-hidden','false'); document.documentElement.style.overflow='hidden'; setTimeout(()=>input?.focus(),80); }));
    $$('[data-mb-search-close]', panel).forEach((b)=>b.addEventListener('click',close));
  }

  function initPredictiveSearch() {
    $$('[data-mb-search-form]').forEach((wrap) => {
      const input = $('input[type="search"]', wrap);
      const panel = $('[data-mb-predictive]', wrap);
      const results = $('[data-mb-predictive-results]', wrap);
      if (!input || !panel || !results) return;

      const isMobilePanel = panel.classList.contains('mb-predictive--mobile');
      const idleBlocks = $$('[data-mb-search-idle]', panel);
      const liveBlock = $('[data-mb-search-live]', panel);
      const allLink = $('[data-mb-search-all]', panel);
      const form = input.closest('form');
      let controller;
      let timer;

      const open = () => { if (!isMobilePanel) panel.classList.add('is-open'); };
      const close = () => { if (!isMobilePanel) panel.classList.remove('is-open'); };

      const showIdle = () => {
        idleBlocks.forEach((b) => { b.hidden = false; });
        if (liveBlock) liveBlock.hidden = true;
      };
      const showLive = () => {
        idleBlocks.forEach((b) => { b.hidden = true; });
        if (liveBlock) liveBlock.hidden = false;
      };

      const hasIdleContent = idleBlocks.length > 0;
      showIdle();

      input.addEventListener('focus', () => {
        const q = input.value.trim();
        if (q.length >= 2 && results.children.length) { showLive(); open(); }
        else if (hasIdleContent) { showIdle(); open(); }
      });

      input.addEventListener('input', () => {
        clearTimeout(timer);
        const q = input.value.trim();
        if (allLink) allLink.href = `/search?q=${encodeURIComponent(q)}`;
        if (q.length < 2) {
          results.innerHTML = '';
          if (hasIdleContent) { showIdle(); open(); } else { close(); }
          return;
        }
        timer = setTimeout(async () => {
          controller?.abort();
          controller = new AbortController();
          try {
            const url = `/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product,query&resources[limit]=6&resources[options][unavailable_products]=last`;
            const r = await fetch(url, { signal: controller.signal, headers: { Accept: 'application/json' } });
            if (!r.ok) return;
            const data = await r.json();
            const products = data?.resources?.results?.products || [];
            if (!products.length) {
              results.innerHTML = `<div style="grid-column:1/-1;font-size:13.5px;font-weight:600;color:#3c6467">Geen producten gevonden. Probeer een andere zoekterm.</div>`;
              showLive();
              open();
              return;
            }
            results.innerHTML = products.map((p) => {
              const img = p.image || '';
              const price = p.price || '';
              return `<a class="mb-predictive__item" href="${p.url}">
                ${img ? `<img src="${img}" alt="">` : '<div class="mb-predictive__item-placeholder"></div>'}
                <div class="mb-predictive__title">${escapeHtml(p.title)}</div>
                <div class="mb-predictive__price">${escapeHtml(price)}</div>
              </a>`;
            }).join('');
            showLive();
            open();
          } catch (e) {
            if (e.name !== 'AbortError') close();
          }
        }, 180);
      });

      $$('[data-mb-suggest]', panel).forEach((chip) => {
        chip.addEventListener('click', () => {
          const term = chip.dataset.mbSuggest || chip.textContent.trim();
          input.value = term;
          if (form) form.submit();
        });
      });

      const scroller = $('[data-mb-search-scroller]', panel);
      if (scroller) {
        const track = $('[data-mb-search-track]', scroller);
        const prev = $('[data-mb-search-prev]', scroller);
        const next = $('[data-mb-search-next]', scroller);
        const progress = $('[data-mb-search-progress]', scroller);
        const step = () => Math.max(160, Math.round(track.clientWidth * 0.6));
        const sync = () => {
          const max = track.scrollWidth - track.clientWidth;
          if (prev) prev.disabled = track.scrollLeft <= 2;
          if (next) next.disabled = track.scrollLeft >= max - 2;
          if (progress) {
            const visible = track.clientWidth / (track.scrollWidth || 1);
            const offset = max > 0 ? track.scrollLeft / max : 0;
            progress.style.width = `${Math.min(100, visible * 100)}%`;
            progress.style.marginLeft = `${offset * (100 - Math.min(100, visible * 100))}%`;
          }
        };
        prev?.addEventListener('click', () => { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
        next?.addEventListener('click', () => { track.scrollBy({ left: step(), behavior: 'smooth' }); });
        track.addEventListener('scroll', sync, { passive: true });
        window.addEventListener('resize', sync);
        setTimeout(sync, 60);
      }

      document.addEventListener('click', (e) => {
        if (!wrap.contains(e.target)) close();
      });
      input.addEventListener('keydown', (e) => { if (e.key === 'Escape') close(); });
    });
  }

  function escapeHtml(s) {
    return String(s ?? '').replace(/[&<>'"]/g, (c) => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[c]));
  }

  function initGallery() {
    $$('[data-mb-gallery]').forEach((gallery) => {
      const hero = $('[data-mb-gallery-hero]', gallery);
      if (!hero) return;
      $$('[data-mb-thumb]', gallery).forEach((btn) => btn.addEventListener('click', () => {
        const src = btn.dataset.src;
        const alt = btn.dataset.alt || '';
        if (src) { hero.src = src; hero.alt = alt; }
        $$('[data-mb-thumb]', gallery).forEach((x) => x.classList.toggle('is-active', x === btn));
      }));
    });
  }

  function initQuantity() {
    $$('[data-mb-qty]').forEach((root) => {
      const input = $('input', root);
      if (!input) return;
      $('[data-mb-minus]', root)?.addEventListener('click', () => {
        input.value = Math.max(Number(input.min || 1), Number(input.value || 1) - 1);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
      $('[data-mb-plus]', root)?.addEventListener('click', () => {
        const max = Number(input.max || 0);
        const next = Number(input.value || 1) + 1;
        input.value = max > 0 ? Math.min(max, next) : next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }

  function initSizeGuides() {
    $$('[data-mb-size-toggle]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const id = btn.getAttribute('aria-controls');
        const panel = id && document.getElementById(id);
        if (!panel) return;
        const open = panel.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', String(open));
      });
    });
  }

  function initBundles() {
    $$('[data-mb-bundles]').forEach((root) => {
      const formId = root.dataset.formId;
      const form = formId ? document.getElementById(formId) : root.closest('form');
      const qty = form?.querySelector('input[name="quantity"]');
      $$('[data-mb-bundle]', root).forEach((option) => {
        option.addEventListener('click', () => {
          $$('[data-mb-bundle]', root).forEach((x) => x.classList.remove('is-selected'));
          option.classList.add('is-selected');
          if (qty) {
            qty.value = option.dataset.qty || '1';
            qty.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      });
    });
  }

  function initUrgency() {
    $$('[data-mb-cutoff]').forEach((el) => {
      const cutoff = String(el.dataset.cutoff || '16:00').split(':');
      const h = Number(cutoff[0] || 23), m = Number(cutoff[1] || 59);
      const out = $('[data-mb-countdown]', el);
      const tick = () => {
        const now = new Date();
        const target = new Date(now);
        target.setHours(h, m, 0, 0);
        if (target <= now) target.setDate(target.getDate() + 1);
        const ms = target - now;
        const hh = Math.floor(ms / 3600000);
        const mm = Math.floor((ms % 3600000) / 60000);
        if (out) out.textContent = `${hh}u ${String(mm).padStart(2,'0')}m`;
      };
      tick();
      setInterval(tick, 30000);
    });
  }

  function initAjaxProductForms() {
    document.addEventListener('submit', async (e) => {
      const form = e.target.closest?.('form.mb-product-form');
      if (!form || !window.fetch || form.dataset.noAjax === 'true') return;
      e.preventDefault();
      const button = form.querySelector('[type="submit"]');
      const old = button?.textContent;
      if (button) { button.disabled = true; button.textContent = 'Toevoegen…'; }
      try {
        const fd = new FormData(form);
        const r = await fetch('/cart/add.js', { method:'POST', body:fd, headers:{ Accept:'application/json' } });
        if (!r.ok) { const err = await r.json().catch(() => ({})); throw new Error(err.description || 'Toevoegen aan winkelwagen is niet gelukt.'); }
        await r.json();
        await refreshCartCount();
        document.dispatchEvent(new CustomEvent('shopify:cart:lines-update', { detail: { action: 'add' } }));
        if (button) button.textContent = 'Toegevoegd ✓';
        const quick = form.closest('[data-mb-quick-modal]');
        if (quick) setTimeout(()=>quick.close?.(), 450);
        setTimeout(() => { if (button) button.textContent = old || 'In winkelwagen'; }, 1400);
      } catch (err) {
        alert(err.message || 'Toevoegen aan winkelwagen is niet gelukt.');
      } finally { if (button) button.disabled = false; }
    });
  }

  function initQuickAdd() {
    const dialog = $('[data-mb-quick-modal]');
    const content = dialog && $('[data-mb-quick-content]', dialog);
    if (!dialog || !content) return;

    const close = () => dialog.close?.();
    $('[data-mb-quick-close]', dialog)?.addEventListener('click', close);
    dialog.addEventListener('click', (e) => { if (e.target === dialog) close(); });

    const stripHtml = (html = '') => {
      const box = document.createElement('div');
      box.innerHTML = String(html || '');
      return (box.textContent || box.innerText || '').replace(/\s+/g, ' ').trim();
    };
    const optionName = (option, index) => {
      if (typeof option === 'string') return option;
      if (option && typeof option.name === 'string') return option.name;
      return `Optie ${index + 1}`;
    };
    const optionValues = (product, option, index) => {
      if (option && Array.isArray(option.values) && option.values.length) {
        return option.values.map((value) => {
          if (typeof value === 'string') return value;
          if (value && typeof value.name === 'string') return value.name;
          return String(value ?? '');
        }).filter(Boolean);
      }
      return [...new Set((product.variants || []).map((variant) => variant.options?.[index]).filter(Boolean))];
    };
    const imageSrc = (image) => {
      if (!image) return '';
      if (typeof image === 'string') return image;
      return image.src || image.url || '';
    };
    const money = (cents) => {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'nl-NL', {
          style: 'currency',
          currency: window.Shopify?.currency?.active || 'EUR'
        }).format((Number(cents) || 0) / 100);
      } catch (_) {
        return `€ ${((Number(cents) || 0) / 100).toFixed(2).replace('.', ',')}`;
      }
    };

    document.addEventListener('click', async (e) => {
      const trigger = e.target.closest?.('[data-mb-quick-open]');
      if (!trigger) return;
      const handle = trigger.dataset.productHandle;
      if (!handle) return;

      content.innerHTML = '<div class="mb-quick-modal__loading"><span class="mb-quick-modal__loader" aria-hidden="true"></span><div><strong>Product laden…</strong><small>Een moment geduld</small></div></div>';
      if (dialog.open) dialog.close();
      dialog.showModal?.();

      try {
        const r = await fetch(`/products/${encodeURIComponent(handle)}.js`, { headers: { Accept: 'application/json' } });
        if (!r.ok) throw new Error('Product kon niet worden geladen.');
        const product = await r.json();
        const variants = product.variants || [];
        const first = variants.find((variant) => variant.available) || variants[0];
        if (!first) throw new Error('Er zijn geen productvarianten beschikbaar.');

        const normalizedOptions = (product.options || []).map((option, index) => ({
          name: optionName(option, index),
          values: optionValues(product, option, index),
          index
        }));
        const visibleOptions = normalizedOptions.filter((option) => {
          if (!option.values.length) return false;
          return !(option.values.length === 1 && /^(default title|default)$/i.test(option.values[0]));
        });

        const optionMarkup = visibleOptions.map((option) => {
          const initial = first.options?.[option.index] || option.values[0];
          const buttons = option.values.map((value) => {
            const availableForValue = variants.some((variant) => variant.available && variant.options?.[option.index] === value);
            const active = value === initial;
            return `<button type="button" class="mb-quick-modal__choice${active ? ' is-active' : ''}" data-mb-quick-option data-index="${option.index}" data-value="${escapeHtml(value)}" aria-pressed="${active ? 'true' : 'false'}" ${availableForValue ? '' : 'disabled'}>${escapeHtml(value)}</button>`;
          }).join('');
          return `<fieldset class="mb-quick-modal__field"><legend>${escapeHtml(option.name)}</legend><div class="mb-quick-modal__choices" role="group" aria-label="${escapeHtml(option.name)}">${buttons}</div></fieldset>`;
        }).join('');
        const oneSizeMarkup = visibleOptions.length === 0
          ? '<div class="mb-quick-modal__field"><span class="mb-quick-modal__fieldlabel">Maat</span><div class="mb-quick-modal__choices"><span class="mb-quick-modal__choice is-active is-static">One size</span></div></div>'
          : '';

        const img = imageSrc(first.featured_image) || imageSrc(product.featured_image);
        const description = stripHtml(product.description || '').slice(0, 170);
        const productUrl = `/products/${encodeURIComponent(handle)}`;

        content.innerHTML = `
          <div class="mb-quick-modal__grid">
            <a class="mb-quick-modal__image" href="${productUrl}" aria-label="Bekijk ${escapeHtml(product.title)}">
              ${img ? `<img src="${escapeHtml(img)}" alt="${escapeHtml(product.title)}">` : '<span>Productfoto</span>'}
            </a>
            <div class="mb-quick-modal__content">
              <div class="mb-quick-modal__eyebrow">Snel toevoegen</div>
              <h2 class="mb-quick-modal__title">${escapeHtml(product.title)}</h2>
              <div class="mb-quick-modal__price" data-mb-quick-price>${money(first.price || product.price)}</div>
              ${description ? `<p class="mb-quick-modal__desc">${escapeHtml(description)}${stripHtml(product.description || '').length > 170 ? '…' : ''}</p>` : ''}
              <form class="mb-product-form mb-quick-modal__form" method="post" action="/cart/add">
                <input type="hidden" name="id" value="${first.id}" data-mb-quick-variant>
                <input type="hidden" name="quantity" value="1">
                <div class="mb-quick-modal__options">${oneSizeMarkup}${optionMarkup}</div>
                <button class="mb-btn mb-btn--primary mb-quick-modal__add" type="submit" ${first.available === false ? 'disabled' : ''}>${first.available === false ? 'Uitverkocht' : 'In winkelwagen'}</button>
              </form>
              <a class="mb-quick-modal__details" href="${productUrl}">Bekijk productdetails <span aria-hidden="true">→</span></a>
            </div>
          </div>`;

        const groups = $$('[data-mb-quick-option]', content);
        const sync = () => {
          const selectedByIndex = {};
          groups.filter((button) => button.classList.contains('is-active')).forEach((button) => {
            selectedByIndex[Number(button.dataset.index)] = button.dataset.value;
          });
          const variant = variants.find((candidate) => {
            return (candidate.options || []).every((value, index) => selectedByIndex[index] === undefined || selectedByIndex[index] === value);
          }) || first;
          const variantInput = $('[data-mb-quick-variant]', content);
          if (variantInput) variantInput.value = variant.id;
          const price = $('[data-mb-quick-price]', content);
          if (price) price.textContent = money(variant.price);
          const btn = content.querySelector('button[type="submit"]');
          if (btn) {
            btn.disabled = !variant.available;
            btn.textContent = variant.available ? 'In winkelwagen' : 'Uitverkocht';
          }
          const variantImage = imageSrc(variant.featured_image);
          if (variantImage) {
            const image = content.querySelector('.mb-quick-modal__image img');
            if (image) image.src = variantImage;
          }
        };

        groups.forEach((button) => button.addEventListener('click', () => {
          if (button.disabled) return;
          const index = button.dataset.index;
          groups.filter((candidate) => candidate.dataset.index === index).forEach((candidate) => {
            const active = candidate === button;
            candidate.classList.toggle('is-active', active);
            candidate.setAttribute('aria-pressed', active ? 'true' : 'false');
          });
          sync();
        }));
        sync();
      } catch (err) {
        content.innerHTML = `<div class="mb-quick-modal__error"><strong>Snel toevoegen is niet gelukt</strong><p>${escapeHtml(err.message || 'Product kon niet worden geladen.')}</p><a class="mb-btn mb-btn--primary" href="/products/${encodeURIComponent(handle)}">Bekijk product</a></div>`;
      }
    });
  }

  function initVariantSelector(scope = document) {
    $$('[data-mb-product-root]', scope).forEach((root) => {
      if (root.mbVariantSelectorReady) return;
      const form = $('form.mb-product-form', root);
      const variantInput = form?.querySelector('input[name="id"]');
      const dataEl = $('[data-mb-variants-json]', root);
      if (!form || !variantInput || !dataEl) return;
      let variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (_) { return; }
      root.mbVariantSelectorReady = true;
      const groups = $$('[data-mb-option-group]', root);
      const sync = () => {
        const selected = groups.map((g) => g.querySelector('input:checked')?.value || '');
        groups.forEach((g,i)=>{ const label=g.querySelector('[data-mb-option-label]'); if(label) label.textContent=selected[i] || ''; });
        const variant = variants.find((v) => v.options.every((x, i) => x === selected[i]));
        if (!variant) return;
        variantInput.value = variant.id;
        const price = $('[data-mb-live-price]', root);
        if (price && variant.price_formatted) price.textContent = variant.price_formatted;
        const button = form.querySelector('[type="submit"]');
        if (button) {
          button.disabled = !variant.available;
          button.textContent = variant.available ? (button.dataset.availableLabel || 'In winkelwagen') : 'Uitverkocht';
        }
        if (variant.featured_image) {
          const hero = $('[data-mb-gallery-hero]', root);
          // mb-pdp.js owns the responsive hero and thumbnail state of the current gallery.
          if (hero && !hero.closest('[data-mb2-gallery]')) hero.src = variant.featured_image;
          root.dataset.mbProductImage = variant.featured_image;
        }
        if (variant.price_formatted) root.dataset.mbProductPrice = variant.price_formatted;
        root.dispatchEvent(new CustomEvent('mb:variant-change', { detail: variant }));
        try { history.replaceState({}, '', `${location.pathname}?variant=${variant.id}`); } catch (_) {}
      };
      groups.forEach((g) => $$('input', g).forEach((i) => i.addEventListener('change', sync)));
      sync();
    });
  }

  document.addEventListener('shopify:section:load', (event) => initVariantSelector(event.target));

  function initAddBoth() {
    $$('[data-mb-add-both]').forEach((button) => {
      button.addEventListener('click', async () => {
        const formId = button.dataset.mainForm;
        const form = formId ? document.getElementById(formId) : null;
        const mainId = form?.querySelector('input[name="id"]')?.value;
        const relatedId = button.dataset.relatedVariant;
        const quantity = Math.max(1, Number(form?.querySelector('input[name="quantity"]')?.value || 1));
        if (!mainId || !relatedId) return;
        const old = button.textContent;
        button.disabled = true;
        button.textContent = 'Toevoegen…';
        try {
          const r = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(mainId), quantity }, { id: Number(relatedId), quantity: 1 }] })
          });
          if (!r.ok) { const err = await r.json().catch(() => ({})); throw new Error(err.description || 'Toevoegen is niet gelukt.'); }
          await r.json();
          await refreshCartCount();
          // Gebruik exact dezelfde cart-confirmation flow als de normale productknop.
          // mb-cart-popup.js luistert zowel naar /cart/add.js als naar dit cart-event
          // en bepaalt zelf de zichtduur via de centrale theme-setting.
          document.dispatchEvent(new CustomEvent('shopify:cart:lines-update', { detail: { action: 'add' } }));
          button.textContent = 'Toegevoegd ✓';
          setTimeout(() => { button.textContent = old || 'In winkelwagen'; }, 1400);
        } catch (err) {
          button.textContent = old;
          alert(err.message || 'Toevoegen is niet gelukt.');
        } finally {
          button.disabled = false;
        }
      });
    });
  }

  function initRecentlyViewed() {
    const key = 'vitabrace_recent_products_v1';
    const currentRoot = $('[data-mb-product-root]');
    let recent = [];
    try {
      const parsed = JSON.parse(localStorage.getItem(key) || '[]');
      if (Array.isArray(parsed)) recent = parsed.filter((x) => x && x.url && x.title).slice(0, 8);
    } catch (_) {}

    const current = currentRoot ? {
      id: currentRoot.dataset.mbProductId || currentRoot.dataset.mbProductHandle || currentRoot.dataset.mbProductUrl,
      handle: currentRoot.dataset.mbProductHandle || '',
      title: currentRoot.dataset.mbProductTitle || '',
      url: currentRoot.dataset.mbProductUrl || '',
      price: currentRoot.dataset.mbProductPrice || '',
      image: currentRoot.dataset.mbProductImage || ''
    } : null;

    const visible = current ? recent.filter((x) => String(x.id) !== String(current.id)) : recent;
    $$('[data-mb-recent-products]').forEach((container) => {
      const items = visible.slice(0, 4);
      const section = container.closest('[data-mb-recent-section]');
      if (!items.length) { if (section) section.hidden = true; return; }
      container.innerHTML = items.map((item) => `<a class="mb-recent-card" href="${escapeHtml(item.url)}">
        ${item.image ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.title)}" loading="lazy">` : '<span class="mb-recent-card__placeholder"></span>'}
        <span><span class="mb-recent-card__name">${escapeHtml(item.title)}</span><span class="mb-recent-card__price">${escapeHtml(item.price || '')}</span></span>
      </a>`).join('');
      if (section) section.hidden = false;
    });

    if (!current || !current.url || !current.title) return;
    const saveCurrent = () => {
      current.price = currentRoot.dataset.mbProductPrice || current.price;
      current.image = currentRoot.dataset.mbProductImage || current.image;
      const next = [current, ...recent.filter((x) => String(x.id) !== String(current.id))].slice(0, 8);
      try { localStorage.setItem(key, JSON.stringify(next)); } catch (_) {}
      recent = next;
    };
    saveCurrent();
    currentRoot.addEventListener('mb:variant-change', saveCurrent);
  }

  function initWelcomePopup() {
    const popups = $$('[data-mb-welcome-popup]');
    if (!popups.length) return;

    // Prefer the global footer-group instance when an older homepage instance still exists.
    const popup = popups.find((item) => item.dataset.mbWelcomeGlobal === 'true') || popups[0];
    popups.forEach((item) => {
      if (item !== popup) {
        item.classList.remove('is-open');
        item.setAttribute('aria-hidden', 'true');
        item.hidden = true;
      }
    });

    const testButton = $('[data-mb-welcome-test]');

    const campaign = (popup.dataset.mbWelcomeCampaign || 'welcome-10-v2')
      .toLowerCase()
      .replace(/[^a-z0-9_-]+/g, '-')
      .replace(/^-+|-+$/g, '') || 'welcome-10-v2';
    const storageKey = `vitabrace_welcome_popup_seen_${campaign}`;
    const designMode = Boolean(window.Shopify && window.Shopify.designMode);
    let opened = false;
    let pendingTimer = null;
    let seen = false;

    try {
      seen = localStorage.getItem(storageKey) === '1';
    } catch (_) {}

    // Storefront: maximaal één daadwerkelijke vertoning per campagne/browser.
    // Theme editor: altijd opnieuw testbaar.
    if (seen && !designMode) return;

    const requestedPercent = Number(popup.dataset.mbWelcomeScroll || 30);
    const scrollPercent = Math.min(80, Math.max(10, Number.isFinite(requestedPercent) ? requestedPercent : 30)) / 100;

    const getDocumentHeight = () => Math.max(
      document.documentElement.scrollHeight || 0,
      document.body?.scrollHeight || 0,
      document.documentElement.offsetHeight || 0,
      document.body?.offsetHeight || 0,
      document.documentElement.clientHeight || 0
    );

    const getScrollProgress = () => {
      const documentHeight = getDocumentHeight();
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
      const scrollableHeight = Math.max(0, documentHeight - viewportHeight);
      if (scrollableHeight <= 0) return 0;
      const scrollTop = Math.max(0, window.pageYOffset || document.documentElement.scrollTop || 0);
      return Math.min(1, scrollTop / scrollableHeight);
    };

    const markSeen = () => {
      if (designMode) return;
      try { localStorage.setItem(storageKey, '1'); } catch (_) {}
    };

    const cleanupListeners = () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onScroll);
      window.removeEventListener('pageshow', onScroll);
    };

    const close = () => {
      popup.classList.remove('is-open');
      popup.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      // In de Theme Editor moet de testknop de popup onbeperkt opnieuw kunnen openen.
      if (designMode) opened = false;
    };

    const open = (force = false) => {
      if (opened && !force) return;
      opened = true;
      if (pendingTimer) {
        window.clearTimeout(pendingTimer);
        pendingTimer = null;
      }
      markSeen();
      popup.classList.add('is-open');
      popup.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      cleanupListeners();
    };

    function onScroll() {
      if (opened || pendingTimer) return;
      if (getScrollProgress() >= scrollPercent) {
        pendingTimer = window.setTimeout(() => {
          pendingTimer = null;
          // Re-check after the small delay because lazy-loaded content can change page height.
          if (getScrollProgress() >= scrollPercent) open();
        }, 350);
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    window.addEventListener('pageshow', onScroll, { passive: true });

    // Re-check after page assets/lazy content have settled.
    window.requestAnimationFrame(onScroll);
    window.setTimeout(onScroll, 700);

    if (designMode && testButton) {
      testButton.addEventListener('click', () => {
        if (pendingTimer) {
          window.clearTimeout(pendingTimer);
          pendingTimer = null;
        }
        // Testmodus negeert scrollpercentage en localStorage volledig.
        opened = false;
        open(true);
      });
    }

    $$('[data-mb-welcome-close]', popup).forEach((button) => button.addEventListener('click', close));
    popup.addEventListener('click', (event) => { if (event.target === popup) close(); });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && popup.classList.contains('is-open')) close();
    });
  }

  // Shopify Theme Editor kan secties live opnieuw renderen zonder een volledige page reload.
  // Initialiseer de popup dan opnieuw, zodat de testknop direct blijft werken.
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target && event.target.querySelector && event.target.querySelector('[data-mb-welcome-popup]')) {
      initWelcomePopup();
    }
  });

  function initBraceQuiz() {
    const root = $('[data-mb-quiz]');
    if (!root) return;

    const zoneInput = $('[data-mb-zone-input]', root);
    const zoneLabel = $('[data-mb-zone-label]', root);
    const question = $('[data-mb-quiz-question]', root);
    const options = $('[data-mb-quiz-options]', root);
    const result = $('[data-mb-quiz-result]', root);
    const resultText = $('[data-mb-quiz-result-text]', root);
    const progress = $$('[data-mb-quiz-progress] span', root);
    const zoneButtons = $$('[data-mb-zone]', root);
    const productsRoot = $('[data-mb-quiz-products]', root);
    const zonePanels = $$('[data-mb-zone-result]', root);
    const stepLabel = $('[data-mb-quiz-step-label]', root);
    const backButton = $('[data-mb-quiz-back]', root);

    const answers = {};
    let step = -1;

    const criterion = (field, value, weight, mode = 'auto') => ({ field, value, weight, mode });
    const option = (label, criteria, summary = '') => ({ label, criteria, summary });

    const zoneConfigs = {
      knie: {
        questions: [
          { stage: 'Gebruik', key: 'moment', q: 'Wanneer wil je de kniebrace vooral gebruiken?', opts: [
            option('Tijdens sport of intensief bewegen', [criterion('sport', true, 6), criterion('useCases', 'Sport', 4, 'list'), criterion('mobility', 'Hoog', 2, 'level')], 'je de brace vooral tijdens sport of intensief bewegen wilt gebruiken'),
            option('Tijdens wandelen en dagelijkse activiteiten', [criterion('useCases', 'Dagelijks', 6, 'list'), criterion('comfort', 'Hoog', 4, 'level'), criterion('mobility', 'Hoog', 2, 'level')], 'comfort tijdens wandelen en dagelijkse activiteiten belangrijk is'),
            option('Tijdens werk waarbij ik veel sta of loop', [criterion('useCases', 'Werk', 7, 'list'), criterion('comfort', 'Hoog', 3, 'level'), criterion('priorityTags', 'Lang dragen', 3, 'list')], 'je de brace tijdens werk en langere draagmomenten wilt gebruiken'),
            option('Tijdens herstel, wanneer ik extra ondersteuning wil', [criterion('recovery', true, 7), criterion('useCases', 'Herstel', 4, 'list'), criterion('stability', 'Hoog', 3, 'level')], 'je tijdens herstel extra ondersteuning zoekt')
          ]},
          { stage: 'Behoefte', key: 'need', q: 'Wat wil je vooral ondersteunen?', opts: [
            option('Vooral rondom mijn knieschijf', [criterion('supportTypes', 'Gerichte druk', 12, 'list'), criterion('priorityTags', 'Bewegingsvrijheid', 3, 'list')], 'je vooral gerichte ondersteuning rondom de knieschijf zoekt'),
            option('Mijn knie voelt niet helemaal stabiel', [criterion('supportTypes', 'Stabilisatie', 7, 'list'), criterion('stability', 'Hoog', 10, 'level'), criterion('priorityTags', 'Stabiliteit', 5, 'list')], 'stabiliteit van de knie voor jou centraal staat'),
            option('Ik wil gelijkmatige compressie rond mijn knie', [criterion('supportTypes', 'Compressie', 10, 'list'), criterion('priorityTags', 'Compressie', 6, 'list'), criterion('comfort', 'Hoog', 2, 'level')], 'je gelijkmatige compressie rondom de knie wilt'),
            option('Ik weet nog niet precies wat ik nodig heb', [criterion('comfort', 'Hoog', 4, 'level'), criterion('adjustable', true, 4), criterion('mobility', 'Hoog', 3, 'level')], 'je vooral een veelzijdige en comfortabele keuze zoekt')
          ]},
          { stage: 'Steunniveau', key: 'support', q: 'Hoeveel ondersteuning wil je voelen?', opts: [
            option('Licht — zo vrij mogelijk blijven bewegen', [criterion('supportLevel', 'Licht', 9, 'support'), criterion('mobility', 'Hoog', 5, 'level')]),
            option('Gemiddeld — duidelijke steun zonder te veel beperking', [criterion('supportLevel', 'Middel', 9, 'support'), criterion('stability', 'Gemiddeld', 4, 'level'), criterion('mobility', 'Hoog', 2, 'level')]),
            option('Stevig — mijn knie duidelijk stabieler laten voelen', [criterion('supportLevel', 'Stevig', 9, 'support'), criterion('stability', 'Hoog', 6, 'level')]),
            option('Zo veel mogelijk stabiliteit en controle', [criterion('stability', 'Hoog', 11, 'level'), criterion('supportLevel', 'Stevig', 8, 'support'), criterion('priorityTags', 'Stabiliteit', 5, 'list')])
          ]},
          { stage: 'Voorkeur', key: 'priority', q: 'Wat vind je tijdens het dragen het belangrijkst?', opts: [
            option('Zo veel mogelijk bewegingsvrijheid', [criterion('mobility', 'Hoog', 8, 'level'), criterion('priorityTags', 'Bewegingsvrijheid', 7, 'list')], 'je zo veel mogelijk bewegingsvrijheid wilt behouden'),
            option('Comfort bij langer dragen', [criterion('comfort', 'Hoog', 8, 'level'), criterion('priorityTags', 'Comfort', 5, 'list'), criterion('priorityTags', 'Lang dragen', 4, 'list')], 'comfort bij langer dragen zwaar meeweegt'),
            option('De ondersteuning zelf kunnen aanpassen', [criterion('adjustable', true, 9), criterion('priorityTags', 'Verstelbaar', 6, 'list')], 'je de ondersteuning graag zelf wilt kunnen afstellen'),
            option('Maximale stabiliteit', [criterion('stability', 'Hoog', 9, 'level'), criterion('priorityTags', 'Stabiliteit', 7, 'list')], 'maximale stabiliteit voor jou het belangrijkst is')
          ]}
        ]
      },

      enkel: {
        questions: [
          { stage: 'Gebruik', key: 'moment', q: 'Wanneer wil je de enkelbrace vooral gebruiken?', opts: [
            option('Tijdens sport en snelle richtingsveranderingen', [criterion('sport', true, 7), criterion('useCases', 'Sport', 4, 'list'), criterion('stability', 'Hoog', 3, 'level')], 'je de brace tijdens sport en snelle bewegingen wilt gebruiken'),
            option('Tijdens wandelen en dagelijkse activiteiten', [criterion('useCases', 'Dagelijks', 7, 'list'), criterion('comfort', 'Hoog', 4, 'level'), criterion('mobility', 'Hoog', 3, 'level')], 'dagelijks comfort en natuurlijk bewegen belangrijk zijn'),
            option('Tijdens werk waarbij ik veel sta of loop', [criterion('useCases', 'Werk', 7, 'list'), criterion('comfort', 'Hoog', 3, 'level'), criterion('priorityTags', 'Lang dragen', 3, 'list')], 'je de enkelbrace tijdens langere werkdagen wilt dragen'),
            option('Tijdens herstel, wanneer ik extra zekerheid wil', [criterion('recovery', true, 7), criterion('useCases', 'Herstel', 4, 'list'), criterion('stability', 'Hoog', 5, 'level')], 'je tijdens herstel extra zekerheid zoekt')
          ]},
          { stage: 'Behoefte', key: 'need', q: 'Wat wil je dat de enkelbrace vooral doet?', opts: [
            option('Lichte compressie geven zonder mijn beweging te beperken', [criterion('supportTypes', 'Compressie', 9, 'list'), criterion('mobility', 'Hoog', 7, 'level'), criterion('stability', 'Laag', 3, 'level')], 'je lichte compressie met veel bewegingsvrijheid zoekt'),
            option('Meer controle geven maar wel natuurlijk laten bewegen', [criterion('supportTypes', 'Stabilisatie', 8, 'list'), criterion('stability', 'Gemiddeld', 7, 'level'), criterion('mobility', 'Hoog', 5, 'level'), criterion('adjustable', true, 3)], 'je een balans tussen enkelcontrole en natuurlijke beweging wilt'),
            option('Mijn enkel zijdelings zo stevig mogelijk stabiliseren', [criterion('supportTypes', 'Stabilisatie', 8, 'list'), criterion('stability', 'Hoog', 11, 'level'), criterion('priorityTags', 'Stabiliteit', 6, 'list')], 'je vooral zijdelingse stabiliteit en controle zoekt'),
            option('Ik weet nog niet precies wat ik nodig heb', [criterion('comfort', 'Hoog', 4, 'level'), criterion('adjustable', true, 4), criterion('mobility', 'Hoog', 3, 'level')], 'je vooral een veelzijdige enkelbrace zoekt')
          ]},
          { stage: 'Steunniveau', key: 'support', q: 'Hoe stevig wil je de enkel ondersteunen?', opts: [
            option('Licht — soepel en schoenvriendelijk', [criterion('supportLevel', 'Licht', 9, 'support'), criterion('mobility', 'Hoog', 5, 'level'), criterion('discreet', true, 3)]),
            option('Gemiddeld — meer controle zonder veel bewegingsverlies', [criterion('supportLevel', 'Middel', 9, 'support'), criterion('stability', 'Gemiddeld', 5, 'level'), criterion('mobility', 'Hoog', 3, 'level')]),
            option('Stevig — duidelijke stabilisatie', [criterion('supportLevel', 'Stevig', 9, 'support'), criterion('stability', 'Hoog', 7, 'level')]),
            option('Zo veel mogelijk stabiliteit', [criterion('stability', 'Hoog', 11, 'level'), criterion('supportLevel', 'Stevig', 8, 'support')])
          ]},
          { stage: 'Voorkeur', key: 'priority', q: 'Wat vind je tijdens het dragen het belangrijkst?', opts: [
            option('Zo veel mogelijk bewegingsvrijheid', [criterion('mobility', 'Hoog', 9, 'level'), criterion('priorityTags', 'Bewegingsvrijheid', 7, 'list')], 'bewegingsvrijheid voor jou vooropstaat'),
            option('Comfort en een lage pasvorm in mijn schoen', [criterion('comfort', 'Hoog', 8, 'level'), criterion('discreet', true, 5), criterion('priorityTags', 'Comfort', 5, 'list')], 'comfort en een lage pasvorm belangrijk zijn'),
            option('De ondersteuning zelf kunnen aanspannen', [criterion('adjustable', true, 9), criterion('priorityTags', 'Verstelbaar', 6, 'list')], 'je de ondersteuning zelf wilt kunnen aanpassen'),
            option('Maximale stabiliteit', [criterion('stability', 'Hoog', 10, 'level'), criterion('priorityTags', 'Stabiliteit', 7, 'list')], 'maximale stabiliteit voor jou het belangrijkst is')
          ]}
        ]
      },

      rug: {
        questions: [
          { stage: 'Gebruik', key: 'moment', q: 'Wanneer wil je de ondersteuning vooral gebruiken?', opts: [
            option('Tijdens lang zitten, autorijden of bureauwerk', [criterion('useCases', 'Zittend werk', 9, 'list'), criterion('comfort', 'Hoog', 5, 'level'), criterion('mobility', 'Hoog', 3, 'level')], 'je vooral ondersteuning tijdens lang zitten of bureauwerk zoekt'),
            option('Tijdens fysiek werk, tillen of actief bewegen', [criterion('useCases', 'Werk', 6, 'list'), criterion('sport', true, 5), criterion('stability', 'Hoog', 5, 'level')], 'je ondersteuning tijdens fysieke belasting wilt'),
            option('Tijdens herstel, wanneer mijn romp extra steun nodig heeft', [criterion('recovery', true, 8), criterion('useCases', 'Herstel', 5, 'list'), criterion('stability', 'Hoog', 4, 'level')], 'je tijdens herstel extra romp- of rugondersteuning zoekt'),
            option('Tijdens zwangerschap of voor ondersteuning van buik en onderrug', [criterion('searchText', ['zwangerschap', 'momfit'], 14, 'text'), criterion('useCases', 'Dagelijks', 3, 'list'), criterion('adjustable', true, 3)], 'je ondersteuning van buik en onderrug tijdens de zwangerschap zoekt')
          ]},
          { stage: 'Behoefte', key: 'need', q: 'Wat wil je vooral van de ondersteuning merken?', opts: [
            option('Comfortabele steun met zo veel mogelijk bewegingsvrijheid', [criterion('comfort', 'Hoog', 9, 'level'), criterion('mobility', 'Hoog', 8, 'level'), criterion('priorityTags', 'Lang dragen', 4, 'list')], 'je comfortabele ondersteuning met veel bewegingsvrijheid wilt'),
            option('Duidelijke ondersteuning van mijn onderrug bij belasting', [criterion('supportTypes', 'Stabilisatie', 7, 'list'), criterion('stability', 'Hoog', 9, 'level'), criterion('mobility', 'Gemiddeld', 3, 'level')], 'je duidelijke lendensteun bij belasting zoekt'),
            option('Mijn beweging bewust sterker beperken voor maximale steun', [criterion('supportTypes', 'Immobilisatie', 13, 'list'), criterion('stability', 'Hoog', 8, 'level'), criterion('mobility', 'Laag', 6, 'level')], 'je beweging bewust meer wilt beperken voor maximale externe steun'),
            option('Gerichte buik- en rompondersteuning met verstelbare compressie', [criterion('searchText', ['postfit', 'buikcompressie', 'rompondersteuning'], 15, 'text'), criterion('recovery', true, 5), criterion('supportTypes', 'Compressie', 5, 'list')], 'je vooral verstelbare buik- en rompondersteuning zoekt')
          ]},
          { stage: 'Steunniveau', key: 'support', q: 'Hoeveel ondersteuning wil je voelen?', opts: [
            option('Licht — comfortabel en flexibel', [criterion('supportLevel', 'Licht', 8, 'support'), criterion('comfort', 'Hoog', 5, 'level'), criterion('mobility', 'Hoog', 4, 'level')]),
            option('Gemiddeld — duidelijke steun voor dagelijks gebruik', [criterion('supportLevel', 'Middel', 9, 'support'), criterion('stability', 'Gemiddeld', 4, 'level')]),
            option('Stevig — duidelijke lenden- of rompstabiliteit', [criterion('supportLevel', 'Stevig', 9, 'support'), criterion('stability', 'Hoog', 7, 'level')]),
            option('Zo veel mogelijk externe stabilisatie', [criterion('stability', 'Hoog', 11, 'level'), criterion('supportTypes', 'Immobilisatie', 8, 'list'), criterion('supportLevel', 'Stevig', 6, 'support')])
          ]},
          { stage: 'Voorkeur', key: 'priority', q: 'Wat vind je tijdens het dragen het belangrijkst?', opts: [
            option('Comfort bij langer zitten of dragen', [criterion('comfort', 'Hoog', 9, 'level'), criterion('priorityTags', 'Lang dragen', 7, 'list')], 'comfort bij langer dragen voor jou belangrijk is'),
            option('Vrij kunnen blijven bewegen', [criterion('mobility', 'Hoog', 9, 'level'), criterion('priorityTags', 'Bewegingsvrijheid', 7, 'list')], 'je zo functioneel mogelijk wilt blijven bewegen'),
            option('De compressie of pasvorm zelf kunnen afstellen', [criterion('adjustable', true, 9), criterion('priorityTags', 'Verstelbaar', 6, 'list')], 'je de pasvorm en ondersteuning zelf wilt kunnen afstellen'),
            option('Maximale stabiliteit', [criterion('stability', 'Hoog', 10, 'level'), criterion('priorityTags', 'Stabiliteit', 7, 'list')], 'maximale stabiliteit vooropstaat')
          ]}
        ]
      },

      pols: {
        questions: [
          { stage: 'Gebruik', key: 'moment', q: 'Wanneer wil je de polsbrace vooral gebruiken?', opts: [
            option('Tijdens typen, computerwerk en dagelijkse activiteiten', [criterion('useCases', 'Zittend werk', 8, 'list'), criterion('useCases', 'Dagelijks', 4, 'list'), criterion('mobility', 'Hoog', 5, 'level')], 'je de brace vooral tijdens typen en dagelijkse activiteiten wilt gebruiken'),
            option('Tijdens sport, krachttraining of actief gebruik', [criterion('sport', true, 7), criterion('useCases', 'Sport', 5, 'list'), criterion('mobility', 'Hoog', 3, 'level')], 'je ondersteuning tijdens sport of actief gebruik zoekt'),
            option('Tijdens grijpen, tillen of repeterend handwerk', [criterion('useCases', 'Werk', 7, 'list'), criterion('searchText', ['grijpen', 'tillen', 'duim'], 9, 'text'), criterion('adjustable', true, 3)], 'je vooral ondersteuning bij grijpen, tillen of repeterend handwerk zoekt'),
            option('Tijdens herstel of rustmomenten', [criterion('recovery', true, 7), criterion('useCases', 'Herstel', 4, 'list'), criterion('stability', 'Hoog', 5, 'level')], 'je tijdens herstel vooral rust en stabilisatie wilt')
          ]},
          { stage: 'Behoefte', key: 'need', q: 'Wat wil je dat de polsbrace vooral doet?', opts: [
            option('Lichte compressie geven terwijl hand en vingers vrij blijven', [criterion('supportTypes', 'Compressie', 8, 'list'), criterion('mobility', 'Hoog', 9, 'level'), criterion('supportLevel', 'Licht', 5, 'support')], 'je lichte compressie wilt terwijl hand en vingers vrij blijven'),
            option('Mijn pols én duimbasis gericht ondersteunen', [criterion('searchText', ['duim', 'manufit'], 13, 'text'), criterion('supportTypes', 'Stabilisatie', 5, 'list'), criterion('stability', 'Gemiddeld', 4, 'level')], 'je gerichte ondersteuning van pols en duimbasis zoekt'),
            option('Mijn polsbeweging duidelijk beperken voor meer rust', [criterion('supportTypes', 'Immobilisatie', 13, 'list'), criterion('mobility', 'Laag', 7, 'level'), criterion('stability', 'Hoog', 7, 'level')], 'je de polsbeweging bewust wilt beperken voor meer rust'),
            option('Ik weet nog niet precies wat ik nodig heb', [criterion('comfort', 'Hoog', 4, 'level'), criterion('adjustable', true, 4), criterion('mobility', 'Hoog', 3, 'level')], 'je vooral een veelzijdige polsbrace zoekt')
          ]},
          { stage: 'Steunniveau', key: 'support', q: 'Hoeveel ondersteuning wil je voelen?', opts: [
            option('Licht — veel bewegingsvrijheid', [criterion('supportLevel', 'Licht', 9, 'support'), criterion('mobility', 'Hoog', 6, 'level')]),
            option('Gemiddeld — duidelijke steun maar nog functioneel bewegen', [criterion('supportLevel', 'Middel', 9, 'support'), criterion('stability', 'Gemiddeld', 5, 'level'), criterion('mobility', 'Gemiddeld', 3, 'level')]),
            option('Stevig — mijn pols duidelijk meer begrenzen', [criterion('supportLevel', 'Stevig', 9, 'support'), criterion('stability', 'Hoog', 7, 'level'), criterion('mobility', 'Laag', 4, 'level')]),
            option('Zo veel mogelijk stabiliteit en rust', [criterion('stability', 'Hoog', 11, 'level'), criterion('supportTypes', 'Immobilisatie', 9, 'list')])
          ]},
          { stage: 'Voorkeur', key: 'priority', q: 'Wat vind je tijdens het dragen het belangrijkst?', opts: [
            option('Makkelijk kunnen typen en mijn hand blijven gebruiken', [criterion('mobility', 'Hoog', 10, 'level'), criterion('priorityTags', 'Bewegingsvrijheid', 7, 'list')], 'je je hand en vingers zo vrij mogelijk wilt blijven gebruiken'),
            option('Comfort bij langer dragen', [criterion('comfort', 'Hoog', 9, 'level'), criterion('priorityTags', 'Lang dragen', 6, 'list'), criterion('priorityTags', 'Comfort', 5, 'list')], 'comfort bij langer dragen belangrijk is'),
            option('De ondersteuning zelf kunnen aanspannen', [criterion('adjustable', true, 9), criterion('priorityTags', 'Verstelbaar', 6, 'list')], 'je de ondersteuning zelf wilt kunnen aanspannen'),
            option('Zo veel mogelijk stabiliteit', [criterion('stability', 'Hoog', 10, 'level'), criterion('priorityTags', 'Stabiliteit', 7, 'list')], 'maximale stabiliteit vooropstaat')
          ]}
        ]
      },

      elleboog: {
        questions: [
          { stage: 'Gebruik', key: 'moment', q: 'Wanneer wil je de elleboogbrace vooral gebruiken?', opts: [
            option('Tijdens racket-, kracht- of andere intensieve sport', [criterion('sport', true, 8), criterion('useCases', 'Sport', 5, 'list'), criterion('mobility', 'Hoog', 3, 'level')], 'je de brace tijdens intensieve sport wilt gebruiken'),
            option('Tijdens werk met veel herhaalde armbewegingen of grijpen', [criterion('useCases', 'Werk', 7, 'list'), criterion('searchText', ['repetitief', 'grijpen', 'tennis', 'golfers'], 7, 'text'), criterion('mobility', 'Hoog', 3, 'level')], 'je ondersteuning bij herhaalde armbewegingen en grijpen zoekt'),
            option('Tijdens dagelijkse activiteiten', [criterion('useCases', 'Dagelijks', 7, 'list'), criterion('comfort', 'Hoog', 5, 'level'), criterion('mobility', 'Hoog', 3, 'level')], 'je vooral dagelijkse ondersteuning zoekt'),
            option('Tijdens herstel, wanneer ik extra controle wil', [criterion('recovery', true, 7), criterion('useCases', 'Herstel', 4, 'list'), criterion('stability', 'Gemiddeld', 5, 'level')], 'je tijdens herstel extra controle wilt')
          ]},
          { stage: 'Behoefte', key: 'need', q: 'Wat wil je vooral ondersteunen?', opts: [
            option('Gerichte druk net onder de elleboog', [criterion('supportTypes', 'Gerichte druk', 13, 'list'), criterion('adjustable', true, 4)], 'je gerichte druk net onder de elleboog zoekt'),
            option('De hele elleboog met gelijkmatige compressie', [criterion('supportTypes', 'Compressie', 10, 'list'), criterion('priorityTags', 'Compressie', 6, 'list'), criterion('comfort', 'Hoog', 3, 'level')], 'je gelijkmatige compressie rondom de elleboog wilt'),
            option('Meer controle en stabiliteit rond het gewricht', [criterion('supportTypes', 'Stabilisatie', 9, 'list'), criterion('stability', 'Gemiddeld', 8, 'level'), criterion('adjustable', true, 4)], 'je meer controle en stabiliteit rond het gewricht zoekt'),
            option('Ik weet nog niet precies wat ik nodig heb', [criterion('comfort', 'Hoog', 4, 'level'), criterion('mobility', 'Hoog', 4, 'level'), criterion('adjustable', true, 3)], 'je vooral een comfortabele allround keuze zoekt')
          ]},
          { stage: 'Steunniveau', key: 'support', q: 'Hoeveel ondersteuning wil je voelen?', opts: [
            option('Licht — gericht en zo vrij mogelijk bewegen', [criterion('supportLevel', 'Licht', 9, 'support'), criterion('mobility', 'Hoog', 6, 'level')]),
            option('Gemiddeld — duidelijke compressie en controle', [criterion('supportLevel', 'Middel', 9, 'support'), criterion('stability', 'Gemiddeld', 6, 'level')]),
            option('Steviger — extra controle zonder mijn arm volledig vast te zetten', [criterion('stability', 'Gemiddeld', 8, 'level'), criterion('supportTypes', 'Stabilisatie', 7, 'list'), criterion('adjustable', true, 3)]),
            option('Ik wil vooral gerichte ondersteuning, niet per se een zware brace', [criterion('supportTypes', 'Gerichte druk', 10, 'list'), criterion('supportLevel', 'Licht', 5, 'support'), criterion('mobility', 'Hoog', 5, 'level')])
          ]},
          { stage: 'Voorkeur', key: 'priority', q: 'Wat vind je tijdens het dragen het belangrijkst?', opts: [
            option('Een compacte en gerichte ondersteuning', [criterion('supportTypes', 'Gerichte druk', 10, 'list'), criterion('discreet', true, 5), criterion('mobility', 'Hoog', 4, 'level')], 'je een compacte, gerichte oplossing belangrijk vindt'),
            option('Comfort en compressie rondom de hele elleboog', [criterion('comfort', 'Hoog', 8, 'level'), criterion('priorityTags', 'Compressie', 7, 'list')], 'comfort en gelijkmatige compressie vooropstaan'),
            option('De ondersteuning zelf kunnen aanpassen', [criterion('adjustable', true, 9), criterion('priorityTags', 'Verstelbaar', 7, 'list')], 'je de ondersteuning graag zelf wilt kunnen afstellen'),
            option('Een goede balans tussen stabiliteit en bewegingsvrijheid', [criterion('stability', 'Gemiddeld', 8, 'level'), criterion('mobility', 'Hoog', 6, 'level'), criterion('priorityTags', 'Stabiliteit', 5, 'list')], 'je een balans tussen stabiliteit en bewegingsvrijheid zoekt')
          ]}
        ]
      },

      houding: {
        questions: [
          { stage: 'Gebruik', key: 'moment', q: 'Wanneer wil je de houdingbrace vooral dragen?', opts: [
            option('Tijdens bureauwerk of lang zitten', [criterion('useCases', 'Zittend werk', 10, 'list'), criterion('comfort', 'Hoog', 5, 'level')], 'je de brace vooral tijdens bureauwerk of lang zitten wilt dragen'),
            option('Tijdens werk waarbij ik veel sta of loop', [criterion('useCases', 'Werk', 8, 'list'), criterion('comfort', 'Hoog', 4, 'level')], 'je ondersteuning tijdens staand of lopend werk zoekt'),
            option('Tijdens korte momenten om mezelf aan mijn houding te herinneren', [criterion('supportTypes', 'Houdingscorrectie', 9, 'list'), criterion('mobility', 'Hoog', 6, 'level')], 'je vooral een lichte houdingsherinnering zoekt'),
            option('Gedurende langere momenten op de dag', [criterion('priorityTags', 'Lang dragen', 8, 'list'), criterion('comfort', 'Hoog', 8, 'level')], 'je de brace gedurende langere momenten comfortabel wilt dragen')
          ]},
          { stage: 'Behoefte', key: 'need', q: 'Wat wil je vooral van de houdingbrace merken?', opts: [
            option('Een subtiele herinnering om mijn schouders beter te positioneren', [criterion('supportTypes', 'Houdingscorrectie', 10, 'list'), criterion('mobility', 'Hoog', 7, 'level'), criterion('stability', 'Laag', 4, 'level')], 'je vooral een subtiele houdingsherinnering zoekt'),
            option('Verstelbare ondersteuning rond schouders en bovenrug', [criterion('adjustable', true, 9), criterion('supportTypes', 'Houdingscorrectie', 8, 'list')], 'je verstelbare ondersteuning rond schouders en bovenrug wilt'),
            option('Duidelijk voelbare ondersteuning maar nog vrij kunnen bewegen', [criterion('supportTypes', 'Houdingscorrectie', 8, 'list'), criterion('mobility', 'Hoog', 6, 'level'), criterion('priorityTags', 'Bewegingsvrijheid', 4, 'list')], 'je voelbare ondersteuning wilt zonder veel bewegingsbeperking'),
            option('Ik weet nog niet precies wat ik nodig heb', [criterion('comfort', 'Hoog', 5, 'level'), criterion('adjustable', true, 4), criterion('mobility', 'Hoog', 4, 'level')], 'je vooral een comfortabele allround keuze zoekt')
          ]},
          { stage: 'Steunniveau', key: 'support', q: 'Hoe duidelijk wil je de ondersteuning voelen?', opts: [
            option('Licht — vooral een subtiele herinnering', [criterion('supportLevel', 'Licht', 10, 'support'), criterion('stability', 'Laag', 5, 'level')]),
            option('Gemiddeld — merkbare ondersteuning zonder strak gevoel', [criterion('supportLevel', 'Middel', 8, 'support'), criterion('stability', 'Gemiddeld', 5, 'level')]),
            option('Steviger — ik wil de ondersteuning duidelijk voelen', [criterion('stability', 'Gemiddeld', 7, 'level'), criterion('adjustable', true, 4)]),
            option('Mijn belangrijkste doel is vooral houdingsbewustwording', [criterion('supportTypes', 'Houdingscorrectie', 11, 'list'), criterion('mobility', 'Hoog', 5, 'level')])
          ]},
          { stage: 'Voorkeur', key: 'priority', q: 'Wat vind je tijdens het dragen het belangrijkst?', opts: [
            option('Zo min mogelijk bewegingsbeperking', [criterion('mobility', 'Hoog', 10, 'level'), criterion('priorityTags', 'Bewegingsvrijheid', 7, 'list')], 'je zo min mogelijk bewegingsbeperking wilt'),
            option('Comfort bij langer dragen', [criterion('comfort', 'Hoog', 10, 'level'), criterion('priorityTags', 'Lang dragen', 7, 'list')], 'comfort bij langer dragen zwaar meeweegt'),
            option('De pasvorm en spanning zelf kunnen aanpassen', [criterion('adjustable', true, 10), criterion('priorityTags', 'Verstelbaar', 7, 'list')], 'je de pasvorm en spanning zelf wilt kunnen aanpassen'),
            option('Een eenvoudige, lichte ondersteuning voor dagelijks gebruik', [criterion('supportLevel', 'Licht', 8, 'support'), criterion('useCases', 'Dagelijks', 6, 'list'), criterion('comfort', 'Hoog', 4, 'level')], 'je een eenvoudige, lichte ondersteuning voor dagelijks gebruik zoekt')
          ]}
        ]
      }
    };

    const zoneBodyNames = {
      knie: 'knie', enkel: 'enkel', rug: 'rug', pols: 'pols', elleboog: 'elleboog', houding: 'houding'
    };

    function normalize(value) {
      return String(value ?? '').trim().toLowerCase();
    }

    function asList(value) {
      if (Array.isArray(value)) return value.map(normalize).filter(Boolean);
      if (value == null || value === '') return [];
      return String(value).split(/[|;,]/).map(normalize).filter(Boolean);
    }

    function asBool(value) {
      if (typeof value === 'boolean') return value;
      return ['true', '1', 'yes', 'ja'].includes(normalize(value));
    }

    function activeConfig() {
      return zoneConfigs[zoneInput.value] || null;
    }

    function activeZonePanel() {
      return zonePanels.find((panel) => panel.dataset.mbZoneResult === zoneInput.value);
    }

    function readProductMeta(card) {
      const script = $('[data-mb-product-meta]', card);
      if (!script) return null;
      try {
        const raw = JSON.parse(script.textContent);
        return {
          handle: raw.handle || card.dataset.productHandle || '',
          title: raw.title || card.dataset.productTitle || '',
          url: raw.url || card.dataset.productUrl || '',
          bodyPart: normalize(raw.bodyPart),
          supportLevel: normalize(raw.supportLevel),
          useCases: asList(raw.useCases),
          supportTypes: asList(raw.supportTypes),
          stability: normalize(raw.stability),
          mobility: normalize(raw.mobility),
          comfort: normalize(raw.comfort),
          adjustable: asBool(raw.adjustable),
          discreet: asBool(raw.discreet),
          sport: asBool(raw.sport),
          recovery: asBool(raw.recovery),
          priorityTags: asList(raw.priorityTags),
          adviceText: String(raw.adviceText || '').trim(),
          searchText: normalize(`${raw.title || ''} ${raw.adviceText || ''}`)
        };
      } catch (error) {
        console.warn('VitaBrace bracewijzer: productmetafields konden niet worden gelezen.', error);
        return null;
      }
    }

    function activeProducts() {
      const panel = activeZonePanel();
      if (!panel) return [];
      return $$('[data-mb-recommend-product]', panel)
        .map((card, index) => ({ card, meta: readProductMeta(card), index }))
        .filter((item) => item.meta);
    }

    function setActiveZone(zone) {
      zoneButtons.forEach((button) => {
        const active = button.dataset.zone === zone;
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
        button.classList.toggle('is-active', active);
      });

      zonePanels.forEach((panel) => {
        panel.hidden = panel.dataset.mbZoneResult !== zone;
      });

      if (productsRoot) productsRoot.hidden = false;
      resetProductPresentation();
    }

    function collectionUrl(zone) {
      const button = zoneButtons.find((item) => item.dataset.zone === zone && item.dataset.collectionHandle);
      const handle = button?.dataset.collectionHandle;
      return handle ? `/collections/${handle}` : '/collections/all';
    }

    const levelOrders = {
      supportLevel: ['licht', 'middel', 'stevig'],
      stability: ['laag', 'gemiddeld', 'hoog'],
      mobility: ['laag', 'gemiddeld', 'hoog'],
      comfort: ['laag', 'gemiddeld', 'hoog']
    };

    function levelScore(actual, wanted, weight, field) {
      const order = levelOrders[field];
      if (!order) return normalize(actual) === normalize(wanted) ? weight : 0;
      const a = order.indexOf(normalize(actual));
      const w = order.indexOf(normalize(wanted));
      if (a < 0 || w < 0) return 0;
      const distance = Math.abs(a - w);
      if (distance === 0) return weight;
      if (distance === 1) return weight * 0.35;
      return 0;
    }

    function criterionScore(meta, item) {
      const field = item.field;
      const wanted = item.value;
      const weight = Number(item.weight || 0);
      const actual = meta[field];

      if (item.mode === 'list') {
        const actualList = asList(actual);
        const wantedList = asList(wanted);
        return wantedList.some((value) => actualList.includes(value)) ? weight : 0;
      }

      if (item.mode === 'text') {
        const haystack = normalize(actual);
        const needles = Array.isArray(wanted) ? wanted : [wanted];
        return needles.some((needle) => haystack.includes(normalize(needle))) ? weight : 0;
      }

      if (item.mode === 'level' || item.mode === 'support') {
        return levelScore(actual, wanted, weight, field);
      }

      if (typeof wanted === 'boolean') {
        return Boolean(actual) === wanted ? weight : 0;
      }

      return normalize(actual) === normalize(wanted) ? weight : 0;
    }

    function scoreProduct(product) {
      const selectedBody = zoneBodyNames[zoneInput.value] || zoneInput.value;
      const bodyMatches = !product.meta.bodyPart || product.meta.bodyPart === normalize(selectedBody);
      if (!bodyMatches) return -10000;

      let score = product.meta.bodyPart ? 20 : 0;
      Object.values(answers).forEach((answer) => {
        (answer?.criteria || []).forEach((item) => {
          score += criterionScore(product.meta, item);
        });
      });
      return score;
    }

    function rankedProducts() {
      return activeProducts()
        .map((product) => ({ ...product, score: scoreProduct(product) }))
        .filter((product) => product.score > -1000)
        .sort((a, b) => b.score - a.score || a.index - b.index);
    }

    function clearRecommendation() {
      zonePanels.forEach((panel) => {
        const recommendations = $('[data-mb-recommendations]', panel);
        if (recommendations) recommendations.hidden = true;
        $$('[data-mb-recommend-product]', panel).forEach((card) => { card.hidden = true; });
      });
    }

    function resetProductPresentation() {
      const panel = activeZonePanel();
      if (!panel) return;
      const heading = $('[data-mb-product-list-title]', panel);
      const eyebrow = $('[data-mb-product-list-eyebrow]', panel);
      if (heading && !heading.dataset.originalText) heading.dataset.originalText = heading.textContent;
      if (eyebrow && !eyebrow.dataset.originalText) eyebrow.dataset.originalText = eyebrow.textContent;
      if (heading) heading.textContent = heading.dataset.originalText || heading.textContent;
      if (eyebrow) eyebrow.textContent = eyebrow.dataset.originalText || eyebrow.textContent;
      $$('[data-mb-grid-product]', panel).forEach((item) => {
        item.hidden = false;
        const tag = $('[data-mb-alt-tag]', item);
        if (tag) { tag.hidden = true; tag.textContent = ''; }
      });
      const reasons = $('[data-mb-match-reasons]', panel);
      if (reasons) { reasons.hidden = true; reasons.innerHTML = ''; }
    }

    function presentAlternatives(ranking, selectedHandle) {
      const panel = activeZonePanel();
      if (!panel) return;
      const grid = $('[data-mb-product-grid]', panel);
      if (!grid) return;

      const scoreMap = new Map(ranking.map((item) => [item.meta.handle, item.score]));
      const selected = ranking.find((item) => item.meta.handle === selectedHandle);
      const supportOrder = { licht: 1, middel: 2, gemiddeld: 2, stevig: 3 };
      const selectedSupport = supportOrder[normalize(selected?.meta.supportLevel)] || 0;
      const items = $$('[data-mb-grid-product]', grid);
      items.sort((a, b) => (scoreMap.get(b.dataset.mbGridProduct) ?? -1) - (scoreMap.get(a.dataset.mbGridProduct) ?? -1));
      items.forEach((item) => grid.appendChild(item));

      items.forEach((item) => {
        const isSelected = item.dataset.mbGridProduct === selectedHandle;
        const tag = $('[data-mb-alt-tag]', item);
        if (isSelected) {
          item.hidden = items.length > 1;
          if (tag) tag.hidden = true;
          return;
        }
        item.hidden = false;
        if (!tag) return;
        const altSupport = supportOrder[normalize(item.dataset.supportLevel)] || 0;
        let label = 'Andere passende optie';
        if (selectedSupport && altSupport) {
          if (altSupport > selectedSupport) label = 'Meer ondersteuning';
          else if (altSupport < selectedSupport) label = 'Lichter alternatief';
          else if (normalize(item.dataset.stability) === 'hoog' && normalize(selected?.meta.stability) !== 'hoog') label = 'Meer stabiliteit';
          else if (normalize(item.dataset.mobility) === 'hoog' && normalize(selected?.meta.mobility) !== 'hoog') label = 'Meer bewegingsvrijheid';
        }
        tag.textContent = label;
        tag.hidden = false;
      });

      const hasAlternatives = items.some((item) => item.dataset.mbGridProduct !== selectedHandle);
      const heading = $('[data-mb-product-list-title]', panel);
      const eyebrow = $('[data-mb-product-list-eyebrow]', panel);
      if (hasAlternatives) {
        if (heading) heading.textContent = 'Andere passende opties';
        if (eyebrow) eyebrow.textContent = 'Alternatieven';
      }
    }

    function showRecommendation() {
      const panel = activeZonePanel();
      const ranking = rankedProducts();
      if (!panel || !ranking.length) return null;

      const selected = ranking[0];
      const recommendations = $('[data-mb-recommendations]', panel);
      $$('[data-mb-recommend-product]', panel).forEach((card) => {
        card.hidden = card !== selected.card;
      });
      if (recommendations) recommendations.hidden = false;
      const reasons = $('[data-mb-match-reasons]', panel);
      if (reasons) {
        const values = [
          selected.meta.supportLevel ? `${selected.meta.supportLevel} steun` : '',
          selected.meta.stability ? `${selected.meta.stability} stabiliteit` : '',
          selected.meta.mobility ? `${selected.meta.mobility} bewegingsvrijheid` : ''
        ].filter(Boolean).slice(0, 3);
        reasons.innerHTML = values.map((value) => `<span>✓ ${escapeHtml(value)}</span>`).join('');
        reasons.hidden = values.length === 0;
      }
      presentAlternatives(ranking, selected.meta.handle);
      return selected;
    }

    function recommendationCopy(selected) {
      if (!selected) return 'We konden nog geen productselectie bepalen.';

      return `Op basis van je antwoorden sluit ${selected.meta.title} binnen ons assortiment het meest aan op de gekozen producteigenschappen. Dit is een productkeuzehulp en geen medische beoordeling.`;
    }

    function updateBackButton(config) {
      if (!backButton) return;
      backButton.hidden = step <= 0;
      if (step >= config.questions.length) backButton.hidden = false;
    }

    function renderQuestion() {
      const config = activeConfig();
      if (!config) return;

      progress.forEach((bar, index) => bar.classList.toggle('is-active', index < step + 1 && step >= 0));
      updateBackButton(config);

      if (step < 0) {
        question.textContent = 'Kies eerst de plek waar je ondersteuning zoekt.';
        options.innerHTML = '';
        if (stepLabel) stepLabel.hidden = true;
        result?.classList.remove('is-visible');
        clearRecommendation();
        return;
      }

      if (step >= config.questions.length) {
        options.innerHTML = '';
        question.textContent = 'Jouw selectie is klaar';
        if (stepLabel) {
          stepLabel.hidden = false;
          stepLabel.textContent = `Gebaseerd op ${config.questions.length} antwoorden`;
        }
        result?.classList.add('is-visible');
        progress.forEach((bar) => bar.classList.add('is-active'));

        const selected = showRecommendation();
        resultText.textContent = recommendationCopy(selected);
        return;
      }

      clearRecommendation();
      resetProductPresentation();
      result?.classList.remove('is-visible');
      const current = config.questions[step];
      if (stepLabel) {
        stepLabel.hidden = false;
        stepLabel.textContent = `Stap ${step + 1} van ${config.questions.length} · ${current.stage}`;
      }
      question.textContent = current.q;
      options.innerHTML = current.opts.map((choice, index) => (
        `<button type="button" class="mb-quiz-option" data-answer-index="${index}"><span class="mb-quiz-letter">${String.fromCharCode(65 + index)}</span><span>${escapeHtml(choice.label)}</span></button>`
      )).join('');

      $$('[data-answer-index]', options).forEach((button) => {
        button.addEventListener('click', () => {
          const index = Number(button.dataset.answerIndex);
          answers[current.key] = current.opts[index];
          step += 1;
          renderQuestion();
        });
      });
    }

    if (backButton) {
      backButton.addEventListener('click', () => {
        const config = activeConfig();
        if (!config || step <= 0) return;
        if (step >= config.questions.length) step = config.questions.length - 1;
        else step -= 1;
        renderQuestion();
      });
    }

    zoneButtons.forEach((button) => {
      button.addEventListener('click', () => {
        const zone = button.dataset.zone;
        if (!zoneConfigs[zone]) return;

        zoneInput.value = zone;
        zoneLabel.textContent = button.dataset.label || zone;
        Object.keys(answers).forEach((key) => delete answers[key]);
        clearRecommendation();
        setActiveZone(zone);
        step = 0;
        renderQuestion();

        if (window.matchMedia('(max-width: 989px)').matches) {
          const panel = root.querySelector('.mb-quiz-panel');
          if (panel) {
            const headerOffset = 88;
            const top = panel.getBoundingClientRect().top + window.scrollY - headerOffset;
            window.scrollTo({ top: Math.max(0, top), left: window.scrollX, behavior: 'smooth' });
          }
        }
      });
    });

    if (productsRoot) productsRoot.hidden = true;
    clearRecommendation();
    if (stepLabel) stepLabel.hidden = true;
    if (backButton) backButton.hidden = true;
    renderQuestion();
  }

  function initSizeAdvice() {
    $$('[data-mb-size-advice]').forEach((root) => {
      const buttons = $$('[data-mb-size-zone]', root);
      const panels = $$('[data-mb-size-panel]', root);
      const select = $('[data-mb-size-product-select]', root);
      const measure = $('[data-mb-size-measure]', root);
      const unit = $('[data-mb-size-unit]', root);
      const calculate = $('[data-mb-size-calculate]', root);
      const answer = $('[data-mb-size-answer]', root);
      const productHelp = $('[data-mb-size-product-help]', root);
      const productScripts = $$('[data-mb-size-product]', root);
      if (!buttons.length || !panels.length) return;

      const products = productScripts.map((script) => {
        try {
          return { ...JSON.parse(script.textContent), zone: script.dataset.zone || '' };
        } catch (_) {
          return null;
        }
      }).filter(Boolean);

      let activeZone = '';

      const parseNumber = (value) => Number(String(value || '').replace(',', '.'));
      const parseSizeTable = (table) => {
        if (!table) return [];
        return String(table)
          .split(/\r?\n|;|<br\s*\/?\s*>/i)
          .map((line) => line.trim())
          .filter(Boolean)
          .map((line) => {
            const parts = line.split(':');
            if (parts.length < 2) return null;
            const size = parts.shift().trim();
            const range = parts.join(':');
            const match = range.match(/([0-9]+(?:[.,][0-9]+)?)\s*(?:-|–|—|tot)\s*([0-9]+(?:[.,][0-9]+)?)/i);
            if (!match) return null;
            return { size, min: parseNumber(match[1]), max: parseNumber(match[2]) };
          })
          .filter((row) => row && Number.isFinite(row.min) && Number.isFinite(row.max));
      };

      const showAnswer = (html, state = 'success') => {
        if (!answer) return;
        answer.className = `mb-size-advice-answer is-${state}`;
        answer.innerHTML = html;
        answer.hidden = false;
      };

      const hideAnswer = () => { if (answer) answer.hidden = true; };

      const selectedProduct = () => {
        if (!select || !select.value) return null;
        return products.find((product) => String(product.id) === String(select.value)) || null;
      };

      const updateProduct = () => {
        const product = selectedProduct();
        hideAnswer();
        if (productHelp) {
          const help = String(product?.measureHelp || '').trim();
          if (help) {
            productHelp.textContent = help;
            productHelp.hidden = false;
          } else {
            productHelp.hidden = true;
          }
        }
        if (unit) unit.textContent = product?.unit || 'cm';
        if (measure) {
          measure.value = '';
          measure.disabled = Boolean(product?.oneSize);
          measure.placeholder = product?.oneSize ? 'Niet nodig' : 'Bijv. 38';
        }
        if (calculate) calculate.disabled = !product;
        if (product?.oneSize) {
          showAnswer(`<span class="mb-size-advice-answer__eyebrow">Jouw maat</span><strong>One size</strong><p>Dit model is verstelbaar en heeft geen aparte maatberekening nodig.</p><a href="${escapeHtml(product.url)}">Bekijk product →</a>`);
        }
      };

      const populateProducts = (zone) => {
        if (!select) return;
        const matches = products.filter((product) => product.zone === zone);
        select.innerHTML = `<option value="">Kies een product</option>${matches.map((product) => `<option value="${escapeHtml(product.id)}">${escapeHtml(product.title)}</option>`).join('')}`;
        select.disabled = matches.length === 0;
        if (!matches.length) select.innerHTML = '<option value="">Nog geen producten in deze zone</option>';
        updateProduct();
      };

      const activate = (zone) => {
        activeZone = zone;
        buttons.forEach((button) => {
          const active = button.dataset.mbSizeZone === zone;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        panels.forEach((panel) => { panel.hidden = panel.dataset.mbSizePanel !== zone; });
        populateProducts(zone);
      };

      buttons.forEach((button) => button.addEventListener('click', () => activate(button.dataset.mbSizeZone)));
      if (select) select.addEventListener('change', updateProduct);

      if (calculate) {
        calculate.addEventListener('click', () => {
          const product = selectedProduct();
          if (!product) {
            showAnswer('<strong>Kies eerst een product.</strong>', 'warning');
            return;
          }
          if (product.oneSize) {
            updateProduct();
            return;
          }
          const value = parseNumber(measure?.value);
          if (!Number.isFinite(value) || value <= 0) {
            measure?.classList.add('is-invalid');
            showAnswer('<strong>Vul eerst een geldige meetwaarde in.</strong>', 'warning');
            return;
          }
          measure?.classList.remove('is-invalid');
          const ranges = parseSizeTable(product.sizeTable);
          if (!ranges.length) {
            showAnswer(`<span class="mb-size-advice-answer__eyebrow">Productspecifieke maatinformatie</span><strong>Controleer de maattabel van ${escapeHtml(product.title)}</strong><p>Voor dit product staat nog geen numerieke maattabel in de calculator. Gebruik de meetinstructie en maattabel op de productpagina.</p><a href="${escapeHtml(product.url)}">Bekijk maattabel →</a>`, 'info');
            return;
          }
          const exact = ranges.filter((range) => value >= range.min && value <= range.max);
          if (!exact.length) {
            const min = Math.min(...ranges.map((range) => range.min));
            const max = Math.max(...ranges.map((range) => range.max));
            showAnswer(`<span class="mb-size-advice-answer__eyebrow">Meetwaarde ${escapeHtml(String(value))} ${escapeHtml(product.unit || 'cm')}</span><strong>Deze waarde valt buiten de beschikbare maattabel</strong><p>De tabel van dit model loopt van ${min} tot ${max} ${escapeHtml(product.unit || 'cm')}. Neem bij twijfel contact met ons op.</p><a href="${escapeHtml(product.url)}">Bekijk product →</a>`, 'warning');
            return;
          }
          const sizes = exact.map((row) => row.size);
          const sizeLabel = sizes.length > 1 ? sizes.join(' / ') : sizes[0];
          const borderText = sizes.length > 1 ? 'Je meetwaarde ligt op een grens tussen twee maten. Controleer de productspecifieke instructie voordat je bestelt.' : 'Je meetwaarde valt binnen dit maatbereik.';
          showAnswer(`<span class="mb-size-advice-answer__eyebrow">Jouw maat voor ${escapeHtml(product.title)}</span><strong>${escapeHtml(sizeLabel)}</strong><p>${borderText}</p><a href="${escapeHtml(product.url)}">Bekijk product →</a>`);
        });
      }

      if (measure) measure.addEventListener('input', () => measure.classList.remove('is-invalid'));
      if (buttons[0]) activate(buttons[0].dataset.mbSizeZone);
    });
  }

  function initCollectionFilterDrawer() {
    $$('[data-mb-filter-shell]').forEach((root) => {
      const drawer = $('[data-mb-filter-drawer]', root);
      const openButton = $('[data-mb-filter-open]', root);
      const closeButtons = $$('[data-mb-filter-close]', root);
      if (!drawer || !openButton) return;

      const open = () => {
        drawer.classList.add('is-open');
        drawer.setAttribute('aria-hidden', 'false');
        openButton.setAttribute('aria-expanded', 'true');
        document.documentElement.classList.add('mb-filter-open');
        const focusTarget = drawer.querySelector('input:not([disabled]), button:not([disabled]), select:not([disabled])');
        setTimeout(() => focusTarget?.focus(), 80);
      };
      const close = () => {
        drawer.classList.remove('is-open');
        drawer.setAttribute('aria-hidden', 'true');
        openButton.setAttribute('aria-expanded', 'false');
        document.documentElement.classList.remove('mb-filter-open');
        openButton.focus();
      };

      openButton.addEventListener('click', open);
      closeButtons.forEach((button) => button.addEventListener('click', close));
      drawer.addEventListener('click', (e) => {
        if (e.target.matches('[data-mb-filter-drawer]')) close();
      });
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
      });
    });
  }

  function getAmsterdamDeliveryStatus(
    now = new Date(),
    cutoffTime = document.body?.dataset.mbCutoffTime || '16:00',
  ) {
    const parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Amsterdam',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hourCycle: 'h23',
    }).formatToParts(now);

    const values = Object.fromEntries(parts.map((part) => [part.type, part.value]));
    const today = new Date(Date.UTC(Number(values.year), Number(values.month) - 1, Number(values.day)));
    const minutes = (Number(values.hour) * 60) + Number(values.minute);
    const cutoff = /^([01]?\d|2[0-3]):([0-5]\d)$/.exec(String(cutoffTime).trim());
    const cutoffMinutes = cutoff ? (Number(cutoff[1]) * 60) + Number(cutoff[2]) : 16 * 60;

    const addDays = (date, amount) => {
      const next = new Date(date.getTime());
      next.setUTCDate(next.getUTCDate() + amount);
      return next;
    };

    const dateKey = (date) => [
      date.getUTCFullYear(),
      String(date.getUTCMonth() + 1).padStart(2, '0'),
      String(date.getUTCDate()).padStart(2, '0'),
    ].join('-');

    const easterSunday = (year) => {
      const a = year % 19;
      const b = Math.floor(year / 100);
      const c = year % 100;
      const d = Math.floor(b / 4);
      const e = b % 4;
      const f = Math.floor((b + 8) / 25);
      const g = Math.floor((b - f + 1) / 3);
      const h = (19 * a + b - d - g + 15) % 30;
      const i = Math.floor(c / 4);
      const k = c % 4;
      const l = (32 + 2 * e + 2 * i - h - k) % 7;
      const m = Math.floor((a + 11 * h + 22 * l) / 451);
      const month = Math.floor((h + l - 7 * m + 114) / 31);
      const day = ((h + l - 7 * m + 114) % 31) + 1;
      return new Date(Date.UTC(year, month - 1, day));
    };

    const dutchHolidayKeys = (year) => {
      const easter = easterSunday(year);
      const kingsDay = new Date(Date.UTC(year, 3, 27));
      // Wanneer 27 april op zondag valt, wordt Koningsdag op zaterdag 26 april gevierd.
      if (kingsDay.getUTCDay() === 0) kingsDay.setUTCDate(26);
      return new Set([
        `${year}-01-01`,
        dateKey(addDays(easter, -2)),
        dateKey(easter),
        dateKey(addDays(easter, 1)),
        dateKey(kingsDay),
        `${year}-05-05`,
        dateKey(addDays(easter, 39)),
        dateKey(addDays(easter, 49)),
        dateKey(addDays(easter, 50)),
        `${year}-12-25`,
        `${year}-12-26`,
      ]);
    };

    const holidayCache = new Map();
    const isHoliday = (date) => {
      const year = date.getUTCFullYear();
      if (!holidayCache.has(year)) holidayCache.set(year, dutchHolidayKeys(year));
      return holidayCache.get(year).has(dateKey(date));
    };

    const isProcessingDay = (date) => {
      const day = date.getUTCDay();
      return day >= 1 && day <= 5 && !isHoliday(date);
    };

    // Verzending en bezorging vinden plaats van maandag t/m vrijdag, exclusief feestdagen.
    const isDeliveryDay = isProcessingDay;

    const nextProcessingDay = (date) => {
      let candidate = addDays(date, 1);
      while (!isProcessingDay(candidate)) candidate = addDays(candidate, 1);
      return candidate;
    };

    const nextDeliveryDay = (processingDate) => {
      let candidate = addDays(processingDate, 1);
      while (!isDeliveryDay(candidate)) candidate = addDays(candidate, 1);
      return candidate;
    };

    const canProcessToday = isProcessingDay(today) && minutes < cutoffMinutes;
    const processingDate = canProcessToday ? today : nextProcessingDay(today);
    const deliveryDate = nextDeliveryDay(processingDate);
    const daysUntilDelivery = Math.round((deliveryDate - today) / 86400000);
    const todayDay = today.getUTCDay();

    let text;
    if (daysUntilDelivery === 1) {
      text = 'Morgen bezorgd';
    } else if (daysUntilDelivery === 2 && todayDay !== 0 && todayDay !== 6) {
      text = 'Overmorgen bezorgd';
    } else {
      const weekday = new Intl.DateTimeFormat('nl-NL', {
        weekday: 'long',
        timeZone: 'UTC',
      }).format(deliveryDate);
      text = `${weekday.charAt(0).toUpperCase()}${weekday.slice(1)} bezorgd`;
    }

    return {
      text,
      state: daysUntilDelivery === 1 ? 'standard' : 'delayed',
    };
  }

  function updateDynamicDeliveryStatus(root = document) {
    const status = getAmsterdamDeliveryStatus();
    const elements = [];

    if (root instanceof Element && root.matches('[data-mb-delivery-status]')) {
      elements.push(root);
    }
    if (root.querySelectorAll) {
      elements.push(...root.querySelectorAll('[data-mb-delivery-status]'));
    }

    elements.forEach((element) => {
      element.textContent = status.text;
      element.dataset.deliveryState = status.state;
      element.setAttribute('aria-label', `Bezorgindicatie: ${status.text}`);
    });
  }

  function initDynamicDeliveryStatus() {
    updateDynamicDeliveryStatus();

    // Houd de tekst correct als een bezoeker de pagina rond de ingestelde besteltijd open laat staan.
    window.setInterval(() => updateDynamicDeliveryStatus(), 60 * 1000);

    // Ook productcards die later via filters/secties/quiz worden ingevoegd krijgen de juiste status.
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node instanceof Element) updateDynamicDeliveryStatus(node);
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function initCollectionFilterSubmit() {
    $$('[data-mb-filter-form]').forEach((form) => {
      if (form.hasAttribute('data-mb-filter-manual')) return;
      $$('input[type="checkbox"],input[type="radio"]', form).forEach((input) => {
        input.addEventListener('change', () => form.submit());
      });
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.body.classList.add('mb-theme');
    initMobileMenu();
    initMobileSearch();
    initPredictiveSearch();
    initGallery();
    initQuantity();
    initSizeGuides();
    initBundles();
    initUrgency();
    initVariantSelector();
    initAjaxProductForms();
    initQuickAdd();
    initAddBoth();
    initRecentlyViewed();
    initWelcomePopup();
    initBraceQuiz();
    initSizeAdvice();
    initCollectionFilterDrawer();
    initCollectionFilterSubmit();
    initDynamicDeliveryStatus();
  });
})();
